var generic = generic || {};
var site = site || {};

(function ($) {
  site.globalnav = {
    templateContainer: $('.footer-top-v1'),

    collateMessages: function (messages) {
      if (Array.isArray(messages)) {
        var len = messages.length;
        var tmp = [];

        for (var i = 0; i < len; i++) {
          tmp.push(messages[i].text);
        }

        return tmp.join('<br />');
      }

      return;
    },

    initExtras: function () {
      this.templateContainer
        .find('form')
        .on('clickoutside touchstartoutside', function (e) {
          var $me = $(this);

          $me.children('.extra').add($me.children('.form-messages')).slideUp();
          $me.find('.button').css('background-color', '#BDBCBC');
          // $(this).children('.extra').slideUp();
        })
        .children('.extra')
        .each(function () {
          var $self = $(this);
          var $form = $self.parent('form');
          var formHeight = $form.outerHeight(true);

          $self
            .css('bottom', '-' + formHeight + 'px')
            .siblings()
            .find('.form-text')
            .focus(function () {
              $self.add($self.siblings('.form-messages')).slideDown();
              $form.find('.button').css('background-color', '#5DBA98');
            });
        });
    },

    initEmailSignup: function () {
      var self = this;

      // hide the newsletter signup in the footer if they are opted into email promtions
      // but we need to wait until the user data is loaded which is done after all the data is loaded
      $(document).on('user.loaded', function () {
        var user = generic.user.getUser();

        if (user.pc_email_optin == 1) {
          $('.newsletter-signup').hide();
        }
      });

      var emailContainerNode = this.templateContainer.find('.newsletter-signup');

      if (!emailContainerNode) {
        return null;
      }

      var emailFormNode = emailContainerNode.find('form'),
        emailProgressNode = emailContainerNode.find('div.progress'),
        emailSuccessNode = emailContainerNode.find('div.success'),
        emailErrorNode = emailContainerNode.find('div.error');

      emailFormNode.once('newsletter-signup-form').on('submit', function (submitEvt) {
        submitEvt.preventDefault();

        emailSuccessNode.addClass('hidden');
        emailErrorNode.addClass('hidden');
        emailProgressNode.removeClass('hidden');

        // set the ACTION for the email signup based on the whether the PC_EMAIL_PROMOTIONS is checked
        // its not required to sign up so we dont want it set by default
        var action = $("#newsletter-signup input[name='PC_EMAIL_PROMOTIONS']").prop('checked')
          ? 'set'
          : 'unset';

        $("#newsletter-signup input[name='ACTION']").val(action);

        // we want to get all the fields in code because 'serialize' encodes potentially bad emails and decode doesn't decode '+' as spaces
        var fields = [
          'PC_EMAIL_ADDRESS',
          'PC_EMAIL_PROMOTIONS',
          'PC_EMAIL_PROMOTIONS_PRESENT',
          'ACCEPTED_COMMERCIAL',
          'ACCEPTED_COMMERCIAL_PRESENT',
          'ACTION',
          'SMS_PROMOTIONS',
          'SMS_PROMOTIONS_PRESENT',
          'MOBILE_NUMBER',
          'CARRIER_CODE',
          'LAST_SOURCE',
          'LANGUAGE_ID',
          'COUNTRY_ID',
          'LAST_SOURCE',
          'ORIGINAL_SOURCE',
          'redirect_or_text',
          'redirect'
        ];
        var paramObj = {};

        // loop through all the fields and get the values
        $.each(fields, function (index, value) {
          var formField = $('#newsletter-signup input[name=' + value + ']');

          // for the unchecked checkboxes we want to send empty strings to backend for processing
          if (formField.is(':checkbox') && !formField.prop('checked')) {
            paramObj[value] = '';
          } else {
            paramObj[value] = formField.val();
          }
        });
        paramObj['_SUBMIT'] = 'email_sms_signup';

        // Send the data via a json rpc call
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function (jsonRpcResponse) {
            emailProgressNode.addClass('hidden');

            var response = jsonRpcResponse.getData();
            // was the user previously opted into email promotions before this submission?
            // this is a 0/1 value
            var previously_opted_in_email_promotion =
              response.userinfo.previously_opted_in_email_promotion;
            // are we still running special offer codes which are emailed out?
            // this is a 0/1 value
            var special_offer_code_status = response.userinfo.special_offer_code_status;

            // user was not previously opted and we are running special offer emails
            // so show overlay with the offer code
            if (!previously_opted_in_email_promotion && special_offer_code_status) {
              emailFormNode.addClass('success').html('');

              // show popup window with special offer code
              var popupOffer = $('.popup-offer-v1'),
                top = 'auto',
                bottom;

              if ($('body').hasClass('front')) {
                bottom = '5%';
              } else {
                bottom = '20%';
              }
              popupOffer.show();
              popupOffer.find('.outer-wrap.signup').hide();
              popupOffer.find('.outer-wrap.thankyou').show().css({
                top: top,
                bottom: bottom
              });
              if ($('body').hasClass('pg')) {
                $('body.pg').addClass('popup-thankyou');
                // $('body.pg.popup-thankyou .outer-wrap.thankyou').removeClass('hidden');
                bottom = '20%';
                $('body.pg.popup-thankyou .outer-wrap.thankyou').css({
                  top: top,
                  bottom: bottom
                });
              }
            }

            // show normal success message
            else {
              var $success = emailSuccessNode.html();

              emailFormNode.addClass('success').html($success);
            }
          },
          onFailure: function (jsonRpcResponse) {
            var messages = self.collateMessages(jsonRpcResponse.getMessages());

            emailProgressNode.addClass('hidden');
            emailErrorNode.empty();
            emailFormNode.addClass('error');
            emailErrorNode.html(messages).removeClass('hidden');
          }
        });
      });
    },

    gdprRemInfoMessageBox: function () {
      if ($('.info-msg').get(0)) {
        $('.info-msg').remove();
      }
    },

    gdprSetInfoBoxPosition: function (infoLink, infoMessageBox, infoMsgArrow, isMobile) {
      var infoLinkTop = infoLink.offset().top + infoLink.height() + 10;
      var infoLinkLeft = infoLink.offset().left;
      var infoMsgMaxWidth = parseInt(infoMessageBox.css('max-width').replace('px', ''));

      if (isMobile) {
        infoMsgArrow.css({
          left: infoLinkLeft - 10 + 'px'
        });
        infoLinkLeft = 10;
      } else if (
        infoMessageBox.outerWidth(true) === infoMsgMaxWidth &&
        infoLinkLeft + (infoMsgMaxWidth + 25) > screen.width
      ) {
        infoLinkLeft = infoLinkLeft - 480;
        infoMsgArrow.addClass('top-right-arrow');
      }
      infoMessageBox.css({
        top: infoLinkTop + 'px',
        left: infoLinkLeft + 'px'
      });
    },

    gdprToolTip: function (context) {
      if (Drupal.settings.globals_variables.gdpr_compliant) {
        var isMobile =
          typeof Unison !== 'undefined'
            ? Unison.fetch.now().name === 'small'
            : $.cookie('client.isMobile');

        $('body', context).on('click', function(e) {
          if (e.target.className !== 'info-msg' && e.target.className !== 'info-msg__txt') {
            $('.info-msg').addClass('hidden');
          }
          if ($('html').hasClass('colorbox_scroll')) {
            $('html').removeClass('colorbox_scroll');
          }
        });
        $(context).on('click', '.info-link', function (infoEvent) {
          infoEvent.preventDefault();
          var infoLink = $(infoEvent.currentTarget);

          if ($('.popup-offer-v1').is(':visible')) {
            $('html').addClass('colorbox_scroll');
          }
          site.globalnav.gdprRemInfoMessageBox();

          $(
            "<div class='info-msg'><div class='info-msg__arrow'></div><div class='info-msg__txt'></div></div>"
          ).appendTo('body');
          var infoBoxEle = $('#' + infoLink.attr('message-in'));
          var infoMessageBox = $('.info-msg');
          var infoMsgArrow = $('.info-msg__arrow');

          $('.info-msg__txt').html("<div class='info-msg__close'>X</div>" + infoBoxEle.html());

          $(context).on('click', '#cboxClose, .info-msg__close', function (closeEvent) {
            closeEvent.stopPropagation();
            site.globalnav.gdprRemInfoMessageBox();
            if ($('.popup-offer-v1').is(':visible')) {
              $('html').removeClass('colorbox_scroll');
            }
          });

          site.globalnav.gdprSetInfoBoxPosition(infoLink, infoMessageBox, infoMsgArrow, isMobile);
          $(window).on(
            'resize-debounced',
            site.globalnav.gdprSetInfoBoxPosition(infoLink, infoMessageBox, infoMsgArrow, isMobile)
          );
        });
      }
    }
  };

  Drupal.behaviors.emailSignupFooterTopV1 = {
    attach: function (context, settings) {
      site.globalnav.initExtras();
      site.globalnav.initEmailSignup();
      site.globalnav.gdprToolTip(context);
    }
  };
})(jQuery);
